<template>
  <v-layout row wrap justify-center py-5>
    <v-flex xs12 text-xs-center pt-5>
      <h2 class="mid-header mid-primary text-center">Meet The Team //<strong>Join The Team</strong></h2>
    </v-flex>
    <v-flex xs12 md10 lg8 pt-5>
      <v-layout row wrap>
        <v-flex 
          v-for="member in team"
          :key="member.name"
          xs12
          sm6
          md4
        >    
          <v-card
            class="mx-auto team-cards"
            max-width="360"
            height="360"
            :dark="member.step === 2"
            :color="member.step === 2? 'primary': ''"
            text
          >
            <v-card-title class="title font-weight-regular justify-space-between">
              <span>{{ member.name }}<br><small>{{ member.title }}</small></span>
              <v-tooltip v-if="member.linkedIn != null" bottom>
                <template v-slot:activator="{ on, attrs }">
                <a :href="member.linkedIn" v-on="on" v-bind="attrs">
                  <v-avatar
                    color="primary"
                    class="subheading white--text"
                    size="32"
                    :alt="`${member.name.split(' ').slice(0, -1).join(' ')}'s LinkedIn`"          
                  >
                    <v-img
                      :src="require('@/assets/linkedin-logo.svg')"
                      alt="LinkedIn Logo"
                      contain position="center center"
                      height="15"
                    ></v-img>
                  </v-avatar>
                </a>
                </template>
                <span>{{member.name.split(' ').slice(0, -1).join(' ')}}'s LinkedIn</span>
              </v-tooltip>
              <v-tooltip v-if="member.instagram != null" bottom>
                <template v-slot:activator="{ on, attrs }">
                <a :href="member.instagram" v-on="on" v-bind="attrs">
                  <v-avatar
                    color="primary"
                    class="subheading white--text"
                    size="32"
                    :alt="`Visit ${member.name.split(' ').slice(0, -1).join(' ')}'s Instagram`"          
                  >
                    <v-img :src="require('@/assets/ig-glyph.svg')" alt="Instagram Logo" contain position="center center" height="18"></v-img>
                  </v-avatar>
                </a>
                </template>
                <span>Visit {{member.name.split(' ').slice(0, -1).join(' ')}}'s Instagram</span>
                
              </v-tooltip>
              <v-btn
                text
                @click="member.step--"
                v-if="member.step === 2 && member.optIn == true"
                dark
                class="animated rubberBand close-btn"
              >
                Close
              </v-btn>
            </v-card-title>  
            <v-window v-model="member.step">
              <v-window-item :value="1">
                <v-card-text>
                  <v-flex xs12 class="text-xs-center justify-center isflex">                
                    <v-avatar
                      v-if="member.optIn != true"
                      :size="100"
                      color="grey lighten-2"
                    >
                      <img :src="member.imageURL" :alt="`${member.name} one of our ${member.title}s`">            
                    </v-avatar>
                    <v-img height="100" contain v-if="member.optIn == true" :src="member.imageURL" alt="Join the She team!"></v-img>
                  </v-flex>
                  <v-flex xs12 ma-0 class="text-xs-center isflex justify-center">
                    <span class="caption grey--text text--darken-1 text-xs-center">
                      {{ member.shortBio }}
                    </span>
                  </v-flex>
                </v-card-text>
              </v-window-item>        
              <v-window-item :value="2">
                <v-card-text  v-if="member.optIn == null">
                  <div class="overflow white--text">
                    <p>{{ member.longBio }}</p>
                    <p>{{ member.longBio2 }}</p>
                  </div>
                </v-card-text>
                <v-card-text v-else class="pa-3">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      name="name"
                      label="Enter your full name"
                      id="fname"
                      v-model="$store.state.fullName"
                      class="mb-0 pb-0"
                      color="white"
                      required
                      :rules="nameRules"
                    ></v-text-field>
                    <v-text-field
                      name="email"
                      :label="emailMsg"
                      :rules="emailRules"
                      id="email"
                      v-model="$store.state.email"
                      class="mb-0 pb-0"
                      color="white"
                      required
                    ></v-text-field>
                    <v-autocomplete
                      :items="['Fashion', 'Business', 'AI', 'IoT', 'Front End', 'Back End', 'Marketing', 'Other']"
                      label="Expertise"
                      multiple
                      v-model="$store.state.expertise"
                      required
                      :rules="[v => !!v || 'Please choose at least one']"
                    ></v-autocomplete>
                    <v-btn
                      :loading="loading"
                      :disabled="loading || !valid || !complete"
                      rounded
                      text
                      @click="sendIt"
                      class="mt-0 pt-0"
                      light
                      block
                      color="white"
                    >
                    {{teamBtn}}                   
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-window-item>
            </v-window>  
            <v-divider></v-divider>  
            <v-card-actions>        
              <v-spacer></v-spacer>
              <v-btn
                text
                @click.prevent="member.step--"
                v-if="member.step === 2 && member.optIn != true"
                dark
                class="animated rubberBand close-btn"
                href="/#"
              >
                Close
              </v-btn>
              <v-btn
                v-if="member.step === 1 && member.optIn != true"
                dark          
                @click.prevent="member.step++"
                text
                class="animated rubberBand bio-btn primary"
                href="/#"
                :ripple="false"
              >
                Full Bio
              </v-btn>
              <v-btn
                v-if="member.step === 1 && member.optIn == true"
                dark          
                @click.prevent="member.step++"
                text
                class="animated rubberBand bio-btn primary"
                href="/#"
                :ripple="false"
              >
                Get In Touch
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- <v-snackbar
        v-model="snackbar"
        color="error"
        multi-line
        :timeout="timeout"
        top
      >
        {{ error }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar> -->
  </v-layout>
</template>

<script>
import firebase from 'firebase/app';
// import functions from 'firebase/functions';

export default {
  data: () => ({
    emailMsg: 'Enter your email',
    loading: false,
    timeout: 5000,
    snackbar: false,
    valid: true,
    error: '',
    nameRules: [
      v => !!v || 'Name is required'
    ],
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ],
    team: [
      {
      step: 1,
      name: 'Yaffa Tenami',
      title: 'Founding Partner',
      shortBio: 'Saavy Investment Strategist',
      longBio: 'Yaffa is the president of a women’s hairpiece and extensions manufacturer and a chain of styling salons since 1980, all of which she started from her bedroom. She is passionate about hair and hair accessories, and is proud of starting and succeeding in her own business which she started from nothing. She’s also proud of the support she’s able to offer the great family she’s built. Yaffa is a strong woman, a graduate of the “School of Hard Knocks.” and she prides herself on her stubbornness and take-no-$&!* attitude.  Yaffa believes in bartering because it lets traders think about things in more than just money. She describes her fashion sense as classic, chic, and slimming.',
      imageURL: require('@/assets/yaffa.jpg'),
      linkedIn: 'https://www.linkedin.http://www.equibytes.com/com/in/yaffa-tenami-130521177/',
      instagram: null
      },
      {
      step: 1,
      name: 'Irma Orenstein',
      title: 'Founding Partner',
      shortBio: 'World Renowned Architect',
      longBio: 'Irma is a leading architect, interior designer, keynote speaker, and mother of three. She established her office independently, in a strong and powerful feminine environment. Specializing in architectural and design services for the world’s most luxurious apartments, penthouses and properties. Irma is known for her unique design signature on commercial projects and creating bespoke design pieces with some of the world’s finest craftsmen that border on being works of art. Her portfolio of work includes diverse properties in London, Vienna, New York and Tel Aviv. Irma is involved and active in a wide range of social and community issues, related to art, medicine and dance: the Janco Dada Museum, Ein-Hod , the Batsheva Dance company and the Tel Aviv Sourasky Centre.',
      longBio2: 'One of her life achievements was the special Giro D\'Italia tour in Israel on the 70th anniversary, in which Irma was a part of the steering committee and the international relations of the event.',
      imageURL: require('@/assets/irma.jpg'),
      linkedIn: 'https://www.linkedin.com/in/irma-orenstein-0b95bb31/',
      instagram: null
      },
      {
      step: 1,
      name: 'Ariel Fleischer',
      title: 'Founding Builder',
      shortBio: 'Makeup Artist',
      longBio: 'Ariel is a bright, fun millennial woman who’s still a child at heart. She’s a certified professional makeup artist with a passion for fashion, hair, and makeup who also loves the arts and a good Youtube binge. She prides herself on learning to overcome her shyness so she can really, openly be herself. Ariel’s favorite thing about bartering is that it cuts out the middleman and allows traders to think in values beyond paper and coins, instead valuing skills and pre-existing items based on want. Ariel wants to help women see themselves more positively, and wants women to remember that beauty is truly on the inside. Ariel’s taste in fashion is self-described as a mix of “comfortable chic, fun and fresh, and clean cut classic.”',
      imageURL: require('@/assets/ariel.jpg'),
      linkedIn: 'https://www.linkedin.com/in/ariel-fleischer-bb34b8177/',
      instagram: null
      },
      {
      step: 1,
      name: 'Cas Profitt',
      title: 'Founding Builder',
      shortBio: 'Disruption Expert & Writer',
      longBio: 'Cas is a consultant and content marketer to high-tech startups with heart. A self-proclaimed transhumanist, Cas works with all manner of disruptive tech including virtual reality, IoT, and blockchain, but her deepest passions lie in artificial intelligence, mental health / psychology, and words, words, words. She has created presentations on disruptive technology for world leaders in the most advanced countries in the world. She also worked as a team leader at a mom’s community, helping women across the globe increase their fertility and grow their families. With a strong belief in minimalist philosophies, Cas believes bartering is beneficial economically and environmentally—reducing waste, increasing appreciation for what we have, and saving money at once. Cas believes in accepting and celebrating the similarities and differences between all genders, our many differing talents and designs, rather than forcing across-the-board equality and homogeneity in all things.  Her style is vintage, nerdy, and practical (and she LOVES polka dots)!',
      imageURL: require('@/assets/cas.jpg'),
      linkedIn: 'https://www.linkedin.com/in/casproffitt/',
      instagram: null
      },
      {
      step: 1,
      name: 'Matthew Profitt',
      title: 'Founding Builder',
      shortBio: 'Decentralization Expert & Consultant',
      longBio: 'Matthew is a fintech aficionado who has a resounding passion for all things disruptive, finance, ethical, and decentralized. He is the CMO of one of the world’s largest blockchain consultancies (IBC). Matthew helped launch his first ICO in 2016 after years of writing about emerging blockchain tech, and has since grown with the industry into the STO world. He has spoken among other decentralization experts at Cryptario Summit. Matthew is most proud of his accomplishments which help shape the ethics of the future. He is an avid gamer and, as in his finance career, he has an obsession with in-game numbers and stats. Matthew believes bartering is a door to bring underserved people back into the economy by changing the way value is exchanged. He also believes that women everywhere should have access to a good education in the fields that pique their interest, and he hopes that by supporting women through SHE, he can make business a more all-inclusive environment. Plus, blockchain can bring a voice to everyone without discrimination. Matthew’s style can be described as classic, vintage, and gentlemanly.',
      imageURL: require('@/assets/matt.jpg'),
      linkedIn: 'https://www.linkedin.com/in/fintechproffitt/',
      instagram: null
      },
      {
      step: 1,
      name: 'Ash Puckett',
      title: 'Founding Builder',
      shortBio: 'Disruptive Tech Specialist',
      longBio: 'Ash is a Certified Blockchain Expert (IBM) and tech guru with a passion for software development, blockchain, and illustration. A creative at heart, Ash loves to inspire creativity in others by sharing knowledge and is proud of her work in teaching others about Raspberry Pi mods and projects. In her own creative time, she loves to illustrate comics and play videogames. Ash loves the freedom of choice that comes from bartering. Freedom runs strong in her beliefs, and, to her, the most pressing women’s issue is that surrounding freedom for women in oppressive countries. Ash believes women should be free to pursue their dreams, desires, and career of choice and deserve the same rights as men whether it be driving, voting, or just speaking up to a stranger—women deserve to make these decisions and control their own future. Her fashion sense is clean, retro, and quirky.',
      imageURL: require('@/assets/ash.jpg'),
      linkedIn: 'https://www.linkedin.com/in/ashpuckett/',
      instagram: null
      },
      {
      step: 1,
      name: 'Karim Quazzani',
      title: 'Founding Builder',
      shortBio: 'Master Marketing Disruptor',
      longBio: 'Karim is a master of cost of client acquisition and an accomplished entrepreneur who excels at developing lucrative, unique offers in the digital advertising world. His last business, Animal Backer, had 470k loyal subscribers and annual revenues in excess of $1 million. He prides himself on his role as a businessman and a family man, supporting his beautiful daughter. Karim believes bartering is a global opportunity, one which can put every item owned to work—day or night. He also believes bartering is a gateway to mass-adoption of decentralization and an opportunity to funnel more women into technology while supporting women’s needs worldwide. As a father and a feminist, Karim wants his daughter to grow up in a world that supports her dreams and offers her opportunities to flourish as a woman. He’ll do anything to help facilitate that future. Karim’s style can be described as “sporty.”',
      imageURL: require('@/assets/karim.jpg'),
      linkedIn: 'https://www.linkedin.com/in/karimquazzani/',
      instagram: null
      },
      {
      step: 1,
      name: 'Evan Berger',
      title: 'Founding Lawyer',
      shortBio: 'Structuring Specialist',
      longBio: 'Structuring and packaging up companies for the next evolution of business technology.',
      imageURL: require('@/assets/evan.jpg'),
      linkedIn: 'https://www.linkedin.com/in/evanberger100',
      instagram: null
      },
      {
      step: 1,
      name: 'Jason Hetherington',
      title: 'Founding Builder',
      shortBio: 'Brand Experience Designer',
      longBio: 'Jason gained his desire to innovate front-end interactions while working in the Facebook Marketing Department. He eventually left the workforce to help launch several startups in a wide range of industries. He places a large focus on transferring his tech skills on to his 2 young daughters who love to be involved in his work.',
      imageURL: require('@/assets/jason.jpg'),
      linkedIn: 'https://www.linkedin.com/in/jason-hetherington-467678165/',
      instagram: null
      },
      {
      step: 1,
      name: 'Your Name Here',
      title: 'Join the team!',
      shortBio: 'We need skills like yours!',
      longBio: null,
      imageURL: require('@/assets/happy.png'),
      linkedIn: null,
      optIn: true
      },
    ]
  }),
  methods: {
    sendIt () {
        this.loading = true
        if (this.$refs.form[0].validate()) {
          let addTeam = firebase.functions().httpsCallable('addTeam')
          addTeam({ email: this.$store.state.email, firstName: this.firstName, lastName: this.lastName, expertise: this.$store.state.expertise }).then(result => {
            if (result.data == "good") {
              this.loading = false
              this.$router.push({ name: 'thanks' })
            } else {
              
              let errorTxt = result.data.detail,
                substring = "already"
              if (errorTxt.includes(substring)) {
                this.error = "We already have a submission from you."
                this.snackbar = true
                this.loading = false
                this.$store.state.email = ''
                this.emailMsg = 'Use a different email?'
              } else {
                this.error = `We're pretty sure that's a fake email.`
                this.snackbar = true
                this.loading = false
              }            
            }
          })
        } else {
          this.valid = !this.valid
          this.error = 'Please complete all fields'
        }
      }
  },
  computed: {
    teamBtn () {
      if (this.valid == true && this.complete == true) {
        return 'I Want In'
      } else {
        return 'Complete Form'
      }
    },
    complete () {
      if (this.$store.state.email == '' || this.$store.state.fullName == '' || this.$store.state.expertise == '') {
        return false
      } else {
        return true
      }
    },
    currentTitle () {
      switch (this.step) {
        case 1: return 'Sign-up'
        case 2: return 'Create a password'
        default: return 'Account created'
      }
    },
    firstName () {
      return this.$store.state.fullName.split(' ').slice(0, -1).join(' ')
    },
    lastName () {
      return this.$store.state.fullName.split(' ').slice(-1).join(' ')
    }
  }
}
</script>

<style>
.overflow {
 overflow-y: scroll;
 height: 180px
}
.v-card__text {padding-right: 0}


::-webkit-scrollbar-button{ display: none; height: 13px; border-radius: 0px; background-color: #AAA; } 
::-webkit-scrollbar-button:hover{ background-color: #AAA; } 
::-webkit-scrollbar-thumb{ background-color: #fff; } 
::-webkit-scrollbar-thumb:hover{ background-color: #CCC; } 
::-webkit-scrollbar-track{ background-color: #6D8BF0; } 
::-webkit-scrollbar-track:hover{ background-color: #6D8BF0; } 
::-webkit-scrollbar{ width: 6px; }
.v-card__text.pa-3 {
    min-height: 227px;
}
.v-card__title.title.font-weight-regular.justify-space-between span {
    font-weight: 800;
    color: #6d8bf0;
}

.v-card__title.title.font-weight-regular.justify-space-between span small {
    font-weight: 400;
    color: #35454d;
}
.theme--dark .v-card__title.title.font-weight-regular.justify-space-between span {
    color: #fff;
}

.theme--dark .v-card__title.title.font-weight-regular.justify-space-between span small {
    color: #fff;
}
.theme--light.v-card.team-cards {
    background-color: #fff;
    border-color: #fff;
    color: rgba(0,0,0,0.87);
    border-radius: 10px;
    box-shadow: -1px 3px 9px #0000003b;
}
.mx-auto.v-card.v-card--text.theme--dark.primary {
    border-radius: 10px;
}
span.caption.grey--text.text--darken-1.text-xs-center {
    font-size: 14px !important;
}
.v-tooltip__content {
    background: #6d8bf0;
    border-radius: 6px;
    font-size: medium;
}
.isflex {
  display: flex
}
</style>
